(function (angular) {

  angular.module("alk.email", []);

})(window.angular);

require("./alkEmail.service");


// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-email/module.js